import React, { useState } from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { useApiRequest } from "@utils/ApiRequest";

import { queryClient } from "@libs/reactQuery/queryClient";
import { useMutation } from "@tanstack/react-query";
import useUserInfoStore from "@store/useUserInfoStore";

const Container = styled.button<{ isFollow: boolean; full: boolean }>(
  ({ theme, isFollow, full }) => ({
    minWidth: "12rem",
    width: full ? "100%" : "",
    padding: "1rem 2.4rem",
    fontWeight: theme.fontWeight.light,
    lineHeight: "1.6rem",
    borderRadius: "4px",
    backgroundColor: isFollow ? theme.color.white : theme.color.mint,
    border: isFollow ? `1px solid ${theme.color.mint}` : "none",
    transition: "0.3s ease-in-out",
  }),
);

type Props = {
  isFollow: boolean;
  full?: boolean;
  id: number;
};

const FollowButton = ({ isFollow, full = false, id }: Props) => {
  const { t } = useTranslation();
  const { patchFollow } = useApiRequest();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    mutate();
  };

  const { mutate } = useMutation({
    mutationFn: () => patchFollow(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["followerList"],
      });
      await queryClient.invalidateQueries({
        queryKey: ["followingList"],
      });
      await queryClient.invalidateQueries({
        queryKey: ["sellerInfo"],
      });
      await queryClient.invalidateQueries({
        queryKey: ["userInfo"],
      });
      await queryClient.resetQueries({
        queryKey: ["sellerList"],
      });
      await queryClient.invalidateQueries({
        queryKey: ["sellerFollowCount"],
      });
    },
  });

  return (
    <Container isFollow={isFollow} onClick={handleClick} full={full}>
      {isFollow ? t("팔로잉") : t("팔로우")}
    </Container>
  );
};

export default FollowButton;
